import { ProductsView } from 'modules/Products/types'

export const isProductPriceGuard = (
  obj: any
): obj is ProductsView['model']['prices'][number] => {
  return 'productId' in obj && 'structure' in obj
}
